<template>
    <div class="main-content view" v-if="article && article.page">   
        <div v-if="userToken">
            <div v-if="currentSlug == 'transport'">
                <PassengerShip />
                <CargoShip />
                <AgeRoadMechanicalVehicle />
            </div>
            <div v-if="currentSlug == 'otkhody'">
                <WasteGenerationBySource />   
                <HazardousWaste />   
            </div>
            <div v-if="currentSlug == 'vozdukh'">
                <EmissionsAtmosphericAir />
                <AirQualityInUrban />
                <ConsumptionOzon />
            </div>
            <div v-if="currentSlug == 'vodnye-resursy'">
                <FreshWaterIntake />
                <WaterConsumption />
                <HouseholdWater />
                <WaterSupplied />
                <PublicAccessWater />
                <WaterLoss />
                <DrinkingWater />
                <BiochemicalOxygen />
                <NutrientsWater />
                <PopulationWastewater />
                <PollutedWastewater />
            </div>
            <div v-if="currentSlug == 'energetika'">
                <ProductionOfElectricity />
                <FinalEnergyConsumption />
                <EnergyConsumption />
                <RenewableEnergySources />
            </div>
            <div v-if="currentSlug == 'izmenenie-klimata'">
                <AirTemperature />
                <AtmosphericPrecipitation />
            </div>
            <div v-if="currentSlug == 'zemelnye-resursy'">
                <StructureGround />
            </div>
        </div>    
        <div class="article">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
            <h1 class="module-title" v-if="!article.page.hide_title">{{article.page.transTitle}}</h1>
            <Tabs 
                :tabs="tabs"
                @change="changeTab"
            />
            <div 
                class="body"
                v-if="selectedTabKey == 1"
            >
                <ul 
                    class="children-list"
                    v-if="article.children"
                >   
                    <li 
                        v-for="child in children"
                        :key="child.key"
                        :class="{ 'active-child': child.key == selectedChild }"
                    >  
                        <a @click="openChild(child.key)">
                            {{child.title}}
                        </a>
                    </li>
                </ul>
        
                <div v-if="selectedChild == null || selectedChild == article.page.id">
                    <div class="counter">
                        <span class="counter_item">
                            1
                        </span>
                        <span class="counter_slash">
                            /
                        </span>
                        <span class="counter_item">
                            {{  article.children.length + 1  }}
                        </span>
                    </div>
                    <div v-if="!article.page.hide_content" v-html="article.page.transContent"
                        :id="'article_'+article.page.id"></div>
                    <div class="date-p">Дата последнего изменения:
                        {{ new Date(article.page.updated) | dateFormat('DD.MM.YYYY') }}
                    </div>
                </div>  
                <article 
                    v-for="(child, index) in article.children" 
                    :id="'article_'+child.id"
                >   
                    <div v-if="selectedChild == child.id">
                        <div class="counter">
                            <span class="counter_item">
                                {{ index + 2 }}
                            </span>
                            <span class="counter_slash">
                                /
                            </span>
                            <span class="counter_item">
                                {{  article.children.length + 1  }}
                            </span>
                        </div>
                        <h1 class="article-title" v-if="!child.hide_title">{{child.transTitle}}</h1>
                        <div class="article-body" v-if="!child.hide_content" v-html="child.transContent"></div>
                    </div>    
                </article>  
            </div>
            <div class="article-item" v-show="article.children && selectedTabKey == 2">
                <div 
                    class="indicators" 
                    id="indicators"
                >
                    <h1>Показатели</h1>
                    <div 
                        v-for="child in article.children" 
                        :id="'tab_'+child.id" v-if="child.indicator"
                    >
                        <div class="tab-item">
                            <v-card v-if="child.indicator">
                                <h1 class="indicator-title">{{child.indicator.transName}}</h1>
                                <v-tabs v-model="active_tab[child.id]">
                                    <v-tab 
                                        :key="'table_'+child.id"
                                        @click="isScroll('table_' + child.id)"
                                    >
                                        Таблицы
                                    </v-tab>
                                    <v-tab :key="'graphic_'+child.id">Графики</v-tab>
                                    <v-tab :key="'xls_'+child.id" v-if="child.indicator.transFile">
                                    <!---Диалог-->
                                        <a
                                            class="file-link"
                                            @click="previewDocumentDialog(child.id, true)"
                                        >
                                            Посмотреть файл
                                        </a>
                                        <v-dialog
                                            v-model="previewDocsModal[child.id]"
                                            max-width="1200"
                                        >
                                            <v-card class="modal">
                                                <div class="modal-head">
                                                    <div
                                                        color="modal-close"
                                                        class="modal_close"
                                                        @click="previewDocumentDialog(child.id, false)"
                                                    >
                                                        <img src="../assets/img/close.png" />
                                                    </div>
                                                </div>
                                                <div class="modal-body">
                                                    <VueDocPreview
                                                        :value="baseUrl + child.indicator.fullFilesDirectory"
                                                        type="office"
                                                    />
                                                </div>
                                            </v-card>
                                        </v-dialog>
                                    </v-tab>
                                    <v-tab-item :key="'table_'+child.id">
                                        <v-card>
                                            <v-card-text>
                                                <div 
                                                    v-if="scrollTable"
                                                    class="scroll_table"
                                                >
                                                    <span>
                                                        Прокрутите таблицу
                                                    </span>  
                                                    <div 
                                                        class="scroll_btn"
                                                    >
                                                    <span
                                                        v-if="scrollDirection"
                                                        @click="scrollRight('table_' + child.id, 'left')"
                                                    >
                                                        <img src="../assets/img/arrow.png" />  
                                                    </span> 
                                                    <span 
                                                        v-else
                                                        class="scroll_back"
                                                        @click="scrollRight('table_' + child.id, 'right')"
                                                    >
                                                        <img src="../assets/img/arrow.png" />  
                                                    </span> 
                                                    </div>
                                                </div>
                                                <transition name="fade">
                                                    <div 
                                                        v-if="child.indicator.transTableContent"
                                                        :class="'table_' + child.id"
                                                        :ref="'table_' + child.id"
                                                        v-html="child.indicator.transTableContent"
                                                    ></div>
                                                </transition>    
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                    <v-tab-item 
                                        :key="'graphic_'+child.id">
                                        <v-card>
                                            <v-card-text>
                                                <div v-if="child.indicator.transGraphic"
                                                    v-html="child.indicator.transGraphic"></div>
                                            </v-card-text>
                                        </v-card>
                                    </v-tab-item>
                                </v-tabs>
                            </v-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CMS from '@/model/cms'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            VueDocPreview: () => import('vue-doc-preview'),
            FilterGraph: () => import('@/components/graph/FilterGraph.vue'),
            WasteGenerationBySource: () =>  import('@/components/graph/WasteGenerationBySource.vue'),
            PassengerShip: () => import('@/components/graph/PassengerShip.vue'),
            CargoShip: () => import('@/components/graph/СargoShip.vue'),
            AgeRoadMechanicalVehicle: () => import('@/components/graph/AgeRoadMechanicalVehicle.vue'),
            WasteGenerationBySource: () => import('@/components/graph/WasteGenerationBySource.vue'),
            HouseholdWastePerCapita: () => import('@/components/graph/HouseholdWastePerCapita.vue'),
            HazardousWaste: () => import('@/components/graph/HazardousWaste.vue'),
            EmissionsAtmosphericAir: () => import('@/components/graph/EmissionsAtmosphericAir.vue'),
            AirQualityInUrban: () => import('@/components/graph/AirQualityInUrban.vue'),
            ConsumptionOzon: () => import('@/components/graph/ConsumptionOzon.vue'),
            FreshWaterIntake: () => import('@/components/graph/FreshWaterIntake.vue'),
            WaterConsumption: () => import('@/components/graph/WaterConsumption.vue'),
            HouseholdWater: () => import('@/components/graph/HouseholdWater.vue'),
            WaterSupplied: () => import('@/components/graph/WaterSupplied.vue'),
            PublicAccessWater: () => import('@/components/graph/PublicAccessWater.vue'),
            WaterLoss: () => import('@/components/graph/WaterLoss.vue'),
            DrinkingWater: () => import('@/components/graph/DrinkingWater.vue'),
            BiochemicalOxygen: () => import('@/components/graph/BiochemicalOxygen.vue'),
            NutrientsWater: () => import('@/components/graph/NutrientsWater.vue'),
            PopulationWastewater: () => import('@/components/graph/PopulationWastewater.vue'),
            PollutedWastewater: () => import('@/components/graph/PollutedWastewater.vue'),
            ProductionOfElectricity: () => import('@/components/graph/ProductionOfElectricity.vue'),
            FinalEnergyConsumption: () => import('@/components/graph/FinalEnergyConsumption.vue'),
            EnergyConsumption: () => import('@/components/graph/EnergyСonsumption.vue'),
            RenewableEnergySources: () => import('@/components/graph/RenewableEnergySources.vue'),
            AtmosphericPrecipitation: () => import('@/components/graph/AtmosphericPrecipitation.vue'),
            AirTemperature: () => import('@/components/graph/AirTemperature.vue'),
            StructureGround: () => import('@/components/graph/StructureGround.vue'),
            Tabs: () => import('@/components/Tabs.vue')
        },
        
        data: () => ({
            scrollTable: false,
            scrollDirection: true,
            article: null,
            active_tab: {},
            breadcrumbs: [],
            previewDocsModal: [],
            baseUrl: process.env.VUE_APP_BACK_URL,
            selectedChild: null,
            selectedTabKey: null,
            tabs: [
                {
                    key: 1,
                    title: 'Основной раздел'
                },
                {
                    key: 2,
                    title: 'Показатели'
                },
            ]
        }),
        watch: {
            // при изменениях маршрута запрашиваем данные снова
            $route() {
                if (this.$route.hash != '#indicators') {
                    this.$router.go(0)
                }
            }
        },
        computed: {
            children () {
                let articles = [
                    {
                        key: this.article.page.id,
                        title: this.article.page.transName
                    }
                ]
                
                this.article.children.forEach((item) => {
                    articles.push({
                        key: item.id,
                        title: item.transTitle,
                        hide_title: item.hide_title
                    })
                })

                return articles
            },
            currentSlug() {
                return this.$route.params.slug
            },
            ...mapGetters({
                userToken: 'getUserToken'
            }),
        },
        created () {
            this.scrollToTop()
        },

        mounted () {
            this.fetchData()
        },
        methods: {
            changeTab(key) {
                this.selectedTabKey = key
            },
            scrollRight (divClass, direction) {
                const table = document.querySelector('.' + divClass + ' .table-overflow')
                const scrollWidth = table.scrollWidth - table.offsetWidth

                this.scrollDirection = !this.scrollDirection

                if (direction == 'left') {
                    table.scrollLeft = scrollWidth
                }

                if (direction == 'right') {
                    table.scrollLeft -= scrollWidth
                }

                this.$forceUpdate()
            },

            isScroll(divClass) {
                this.$nextTick(() => {
                    setTimeout(() => {
                       this.getIsScroll(divClass)
                    }, 300)
                })
              
            },

            getIsScroll (divClass) {
                const table = document.querySelector('.' + divClass + ' .table-overflow')
                
                if (table && table.offsetWidth != table.scrollWidth) {
                    this.scrollTable = true
                }

                if (table && table.offsetWidth == table.scrollWidth) {
                    this.scrollTable = false
                }
            },

            previewDocumentDialog(id, flag) {
                this.$set(this.previewDocsModal, id, flag)
            },
            openChild (key) {
                this.selectedChild = key
            },
            fetchData() {
                CMS.loadBlogBySlug(this.$route.params.slug)
                    .then(response => {
                        this.article = response.data;
                        this.breadcrumbs = [
                            {
                                text: 'Главная',
                                disabled: false,
                                href: '/'
                            },
                            {
                                text: this.article.page.transTitle,
                                disabled: true
                            }
                        ];
                        if (this.article.children) {
                            let self = this
                            this.selectedChild = this.article.page.id
                            this.article.children.forEach(function (child) {
                                if (child.indicator) {
                                    self.$set(self.active_tab, child.id, 1)
                                }
                            })
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // Прокручивание к началу страницы
            scrollToTop () {
                window.scrollTo(0, 0)
            }
        },

    }
</script>
<style lang="scss" scoped>
    .traffic_road-graphics {
        display: flex;
    }

    .children-list {
        margin-right: 20px !important;
        max-width: 400px;
        float: left;
        background-color: #eef2ef;
        padding: 20px 20px !important;
    }

    .article-title {
        background: #e0f6fc;
        font-size: 18px;
        font-weight: 500;
        margin-top: 0;
        margin-bottom: 15px;
        padding: 20px;
        text-align: center;
        display: flex;
    }

    .modal_close {
        width: 50px;
        height: 50px;
        padding: 10px;
        float: right;
        cursor: pointer;

        img {
            width: 100%;
        }
    }

    .scroll_table {
        width: 100%;
        font-size: 20px;
        display: flex;
        align-items: center;
        padding: 20px 0px;
        color: #ce252b;

        img {
            width: 30px;
            margin-left: 10px;
        }
    }

    .scroll_btn {
        cursor: pointer;
    }

    .scroll_back img{
        transform: rotate(180deg);
    }

    .counter {
        display: flex;
        align-items: center;

        &_item {
            font-size: 20px;
            color: #7b7b7b;
        }

        &_slash {
            font-size: 25px;
            padding: 0px 5px;
        }
    }

    .indicators {
        background-color: #fff;
        padding: 30px;
    }

    .active-child {
        font-weight: 500;
        color: #4a6328;
        border-bottom: 1px dotted #555855;
    }
</style>